export default __webpack_public_path__ + "static/media/Montserrat-Bold-700.079ca05d.ttf";